import React, { useState } from 'react';

import { Modal } from '@wds/modal';
import { Box } from '@wds/box';

import PropTypes from 'prop-types';

import MFA from '../Authentication/MFA';

const MFAEnrollmentModal = (props) => {
	const {
		open,
		enrolled,
		handleClose,
	} = props;

	const handleOnClose = (completedEnrollment, method) => {
		handleClose(completedEnrollment, method);
	};

	return (
		<Box id='sma-mfa-enrollment-modal'>
			<Modal
				show={open}
				data-testid='mfa-enrollment-modal'
				onClose={handleOnClose}
				dismissible={!enrolled}
			>
				<Modal.Body>
					<MFA isModal handleClose={handleOnClose} />
				</Modal.Body>
			</Modal>
		</Box>
	);
};

MFAEnrollmentModal.propTypes = {
	open: PropTypes.bool.isRequired,
	enrolled: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
};

export default MFAEnrollmentModal;
